<template>
  <div class="cp_list1">
    <div class="field">
      <img src="~@static/funding_cpunk/project_item_1a.png" class="cover1" alt="" />
      <img :src="hostUrl + projectData.picture" alt="" class="img" @click="gotoPage" />
      <img src="~@static/funding_cpunk/project_item_1b.png" class="cover2" alt="" />
      <div class="theme">精选派对</div>
      <div class="t">
        <p class="t1" @click="gotoPage">{{ projectData.event_name }}</p>
        <p class="t2">{{ projectData.event_summary }}</p>
        <div class="t3">
          <div class="t3_1">
            <img class="icon" src="~@static/fundingnew/profile/icon-location.png" />
            <div class="text">{{ projectData.city }}</div>
          </div>
          <div class="t3_2" v-if="projectData.plan_status != '1'">
            <img class="icon" src="~@static/fundingnew/profile/icon-like.png" />
            <div class="text">{{ projectData.total }}</div>
          </div>
        </div>
      </div>
      <div @click="gotoPage" class="project-link">查看详情</div>
    </div>
    <div class="tags-list1 clearfix" v-if="hasTags">
      <div class="item-box" v-for="item of projectData.tags" :key="item.id"># {{ item }}</div>
    </div>
  </div>
</template>

<script>
import { behavior } from '@/utils/behavior'
export default {
  props: {
    hasTags: Boolean,
    hasDesc: Boolean,
    hasProcess: Boolean,
    hasLink: Boolean,
    hasTheme: Boolean,
    isAnnouncement: Boolean,
    isWeekly: Boolean,
    projectData: Object,
    isBili: Boolean,
    isCalendar: Boolean,
  },
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      likedLeast: 100,
      link: '',
    }
  },
  methods: {
    gotoPage() {
      let query = this.$route.query
      if (this.isCalendar) {
        query.path_from = 'calendar'
        _jcq.push([
          '_track',
          'calendarinfo_check',
          {
            title: this.projectData.event_name,
          },
        ])
        behavior({ behavior_code: 'prc_bhv_abs_calendar_bc1', name: this.projectData.event_name })
      } else {
        _jcq.push([
          '_track',
          'yjhbcinfo_check',
          {
            title: this.projectData.event_name,
          },
        ])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc3', name: this.projectData.event_name })
      }
      this.$router.push({ path: this.link, query })
    },
  },
  mounted() {
    this.link = '/fundingnew/project/' + this.projectData.id
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/cpunk.scss';
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/components/ProjectItemCpunk.vue